import React from "react";

function ByBridging() {
  return (
    <>
      {" "}
      <div className="container p-5">
        <div
          className="pricing-style-one-item-cos bg-dark text-light"
          style={{
            backgroundImage:
              "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
          }}
        >
          <div className="text-center">
            <h3>
              By bridging the gap between physical assets and the digital world,
              our services enable you to enhance liquidity, verify ownership,
              and create new value streams!
            </h3>
            <div className="bottom">
              <div className="pricing">
                <p>
                  Whether you're looking to fractionalize ownership, streamline
                  transactions, or create a marketplace for your assets, our NFT
                  solutions are designed to unlock limitless potential and drive
                  innovation in your ecosystem.
                </p>
              </div>
              <a className="btn btn-style-one mt-30" href="#">
                Get Started
              </a>
            </div>
          </div>
          {/* <div className="right-info"></div> */}
        </div>
      </div>
    </>
  );
}

export default ByBridging;
